/**
 * ZIP shape rules, copied from production's `ZipcodeValidator` so a ZIP typed
 * here is accepted and rejected exactly as it is on the pages that share its
 * cookies. No imports.
 */

/** The ZIP the production bootstrap writes when nothing else is known. */
export const FALLBACK_ZIP = "75001";

/** A complete ZIP: exactly five digits. */
export function isValidFullZip(zip: unknown): zip is string {
  return typeof zip === "string" && /^\d{5}$/.test(zip);
}

/**
 * Production's typing filter: keep digits and dots, then take the first run of
 * up to five digits. ⚠ The dot survives the first pass and ENDS the run, so
 * "1.2345" is "1" — reproduced because the legacy field does the same.
 */
export function sanitizeZipInput(value: string): string {
  if (!value) {
    return "";
  }
  return value.replace(/[^0-9.]/g, "").match(/\d{0,5}/)?.[0] || "";
}

/** First five-digit run anywhere in a decoded edge cookie, or "". Unanchored on purpose. */
export function firstFiveDigitRun(value: string): string {
  return value.match(/\d{5}/)?.[0] || "";
}
